import { useEffect, useState } from "react";
import { api, fmtDateRelative } from "../../lib/api";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";

export default function NotesTab({ dealId }) {
    const [notes, setNotes] = useState([]);
    const [content, setContent] = useState("");

    const refresh = async () => {
        const { data } = await api.get(`/deals/${dealId}/activities`);
        setNotes(data.filter((a) => a.type === "note"));
    };
    useEffect(() => { refresh(); }, [dealId]);

    const add = async () => {
        if (!content.trim()) return;
        await api.post(`/deals/${dealId}/notes`, { content });
        setContent("");
        refresh();
    };

    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 max-w-5xl">
            <div className="lg:col-span-2 border border-border rounded-md bg-white p-6">
                <h3 className="font-display font-bold tracking-tight mb-4">Notes</h3>
                <ul className="space-y-3" data-testid="notes-list">
                    {notes.length === 0 && <li className="text-sm text-muted-foreground">No notes yet.</li>}
                    {notes.map((n) => (
                        <li key={n.id} className="p-4 border border-border rounded-md">
                            <div className="text-[10px] uppercase tracking-wider text-muted-foreground font-mono mb-2">
                                {fmtDateRelative(n.created_at)} · {n.user_name}
                            </div>
                            <p className="text-sm leading-relaxed whitespace-pre-wrap">{n.content}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="border border-border rounded-md bg-white p-6 h-fit">
                <h3 className="font-display font-bold tracking-tight mb-4">Add note</h3>
                <Textarea rows={6} value={content} onChange={(e) => setContent(e.target.value)} placeholder="Jot down thoughts, meeting notes, buyer feedback…" data-testid="note-input" />
                <Button onClick={add} className="w-full mt-3 bg-foreground text-background hover:bg-neutral-800 hover:text-white" data-testid="add-note-btn">Save note</Button>
            </div>
        </div>
    );
}
